import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { api } from "@/lib/api";

const ArticleBody = ({ text }) => (
  <div className="max-w-xl space-y-4 text-base text-[#090708]/70 leading-relaxed" data-testid="blog-post-content">
    {text.split(/\n{2,}/).map((block, i) => {
      const b = block.trim();
      if (b.startsWith("## ")) return <h2 key={i} className="font-serif text-2xl text-[#9B6179] pt-6">{b.slice(3)}</h2>;
      if (b.startsWith("• ")) return <p key={i} className="pl-5 relative -mt-2"><span className="absolute left-0 text-[#9B6179]">•</span>{b.slice(2)}</p>;
      return <p key={i} className="whitespace-pre-line">{b}</p>;
    })}
  </div>
);

export default function BlogPost() {
  const { slug } = useParams();
  const { T, lang } = useLanguage();
  const [post, setPost] = useState(null);

  useEffect(() => {
    api.get(`/public/blog/${slug}?lang=${lang}`).then((r) => setPost(r.data)).catch(() => setPost(null));
  }, [slug, lang]);

  if (!post) return <div className="pt-40 text-center text-[#090708]/40">{T.common.loading}</div>;

  return (
    <div className="pt-16 pb-10 px-6 lg:px-16" data-testid="blog-post-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/blog" className="flex items-center gap-1 text-[11px] tracking-widest uppercase text-[#9B6179] mb-10" data-testid="blog-post-back-link">
          <ChevronLeft className="w-3.5 h-3.5" /> {T.blog.back}
        </Link>
        <p className="text-[11px] tracking-widest uppercase text-[#9B6179] mb-3">{post.category}</p>
        <h1 className="font-serif text-4xl lg:text-5xl text-[#9B6179] mb-10 leading-tight">{post.title}</h1>
        <div className="h-72 lg:h-96 overflow-hidden mb-10">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
        <ArticleBody text={post.content || ""} />
      </div>
    </div>
  );
}
